<template>
  <div
    v-if="currentProgress >= 0"
    :class="['progress-bar', { 'progress-bar-white': !isDark }]"
  >
    <nuxt-icon name="checked" />
    <nuxt-icon v-for="step in steps" :key="step" name="checked" :class="{ 'icon-checked': currentProgress >= (100 / steps * step) }" :filled="currentProgress >= (100 / steps * step)" />
    <div class="progress-bar__line">
      <div
        :class="['progress-bar__fill-line', { 'progress-bar__fill-line-empty': currentProgress === 0 }]"
        :style="{ width: `${currentProgress}%` }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useQuiz } from '@/composables/quiz';

defineProps({
  isDark: { type: Boolean, default: false },
});
const { currentProgress, getQuizSteps } = useQuiz();
const steps = ref(3);

onMounted(async () => {
  steps.value = await getQuizSteps();
});
</script>

<style lang="scss" scoped>
.progress-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 10;
  max-width: 311px;
  margin: 0 auto;
  margin-bottom: 32px;
  margin-top: 8px;
  width: 100%;

  .nuxt-icon {
    line-height: 0;
    color: $dark-progress;
    z-index: 12;
    font-size: 18px;

    &:first-child {
      color: $red;
    }
  }

  &__line {
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0;
    right: 0;
    background: $dark-progress;
    z-index: 11;
  }

  &__fill-line {
    position: absolute;
    left: 0;
    background: $red;
    height: 100%;
    border-radius: 43px;
  }

  &__fill-line-empty {
    padding: 0;
  }
}

.progress-bar-white {
  .nuxt-icon {
    color: $gray-bg;

    &:first-child {
      color: $text-color;
    }
  }

  .progress-bar__line {
    background: $gray-bg;
  }

  .progress-bar__fill-line {
    background: $text-color;
  }
}
</style>

<style lang="scss">
.icon-checked {
  path {
    fill: $red;
  }

  circle {
    fill: $dark-progress;
  }
}

.progress-bar-white {
  .icon-checked {
    path {
      fill: $text-color;
    }

    circle {
      fill: $white;
    }
  }
}
</style>
